module.exports = __webpack_public_path__ + "img/UEAL.452362f5.svg";